import React from 'react';
import TimeRangePicker from './TimeRangePicker';
import { TimeBlock } from '../../hooks/venue/useVenueAvailability';

interface DayAvailabilityRowProps {
  dayName: string;
  dayOfWeek: number;
  enabled: boolean;
  blocks: TimeBlock[];
  onToggleDay: (dayOfWeek: number) => void;
  onAddBlock: (dayOfWeek: number) => void;
  onRemoveBlock: (dayOfWeek: number, blockIndex: number) => void;
  onUpdateBlock: (
    dayOfWeek: number,
    blockIndex: number,
    field: 'startTime' | 'endTime' | 'isPeakHour',
    value: any
  ) => void;
}

const DayAvailabilityRow: React.FC<DayAvailabilityRowProps> = ({
  dayName,
  dayOfWeek,
  enabled,
  blocks,
  onToggleDay,
  onAddBlock,
  onRemoveBlock,
  onUpdateBlock,
}) => {
  return (
    <div
      style={{
        backgroundColor: '#23272A',
        border: '1px solid #33383B',
        borderRadius: 12,
        padding: 20,
        marginBottom: 16,
      }}
    >
      {/* Day Header with Toggle */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: enabled ? 20 : 0,
        }}
      >
        <label
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            cursor: 'pointer',
            fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
            fontSize: 20,
            letterSpacing: 0.5,
            color: enabled ? '#00E676' : '#B0BEC5',
          }}
        >
          <input
            type="checkbox"
            checked={enabled}
            onChange={() => onToggleDay(dayOfWeek)}
            style={{
              width: 20,
              height: 20,
              cursor: 'pointer',
              accentColor: '#00E676',
            }}
          />
          {dayName.toUpperCase()}
        </label>

        {!enabled && (
          <span
            style={{
              fontSize: 13,
              color: '#6C757D',
              fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
            }}
          >
            (Cerrado)
          </span>
        )}
      </div>

      {/* Time Blocks */}
      {enabled && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          {blocks.map((block, index) => (
            <div
              key={index}
              style={{
                backgroundColor: '#181A1B',
                padding: 16,
                borderRadius: 10,
                border: '1px solid #33383B',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: 12,
                }}
              >
                <span
                  style={{
                    fontSize: 14,
                    fontWeight: 600,
                    color: '#FFFFFF',
                    fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
                  }}
                >
                  Bloque {index + 1}
                </span>
                {blocks.length > 1 && (
                  <button
                    onClick={() => onRemoveBlock(dayOfWeek, index)}
                    style={{
                      background: 'none',
                      border: 'none',
                      color: '#FF5252',
                      cursor: 'pointer',
                      fontSize: 20,
                      padding: 0,
                    }}
                    title="Eliminar bloque"
                  >
                    🗑️
                  </button>
                )}
              </div>

              <TimeRangePicker
                startTime={block.startTime}
                endTime={block.endTime}
                onStartChange={(time) =>
                  onUpdateBlock(dayOfWeek, index, 'startTime', time)
                }
                onEndChange={(time) =>
                  onUpdateBlock(dayOfWeek, index, 'endTime', time)
                }
              />

              {/* Peak Hour Toggle */}
              <label
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 10,
                  marginTop: 12,
                  cursor: 'pointer',
                  fontSize: 14,
                  color: block.isPeakHour ? '#FFC107' : '#B0BEC5',
                  fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
                }}
              >
                <input
                  type="checkbox"
                  checked={block.isPeakHour}
                  onChange={(e) =>
                    onUpdateBlock(dayOfWeek, index, 'isPeakHour', e.target.checked)
                  }
                  style={{
                    width: 18,
                    height: 18,
                    cursor: 'pointer',
                    accentColor: '#FFC107',
                  }}
                />
                {block.isPeakHour ? '⭐ Horario pico' : 'Horario pico'}
              </label>
            </div>
          ))}

          {/* Add Block Button */}
          <button
            onClick={() => onAddBlock(dayOfWeek)}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 8,
              padding: '12px 16px',
              backgroundColor: '#181A1B',
              border: '1px dashed #00E676',
              borderRadius: 10,
              color: '#00E676',
              fontSize: 14,
              fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
              fontWeight: 500,
              cursor: 'pointer',
              transition: 'all 0.2s',
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = '#1A2E24';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = '#181A1B';
            }}
          >
            + Agregar otro bloque horario
          </button>
        </div>
      )}
    </div>
  );
};

export default DayAvailabilityRow;
